/**
 * Created by andrey on 15.10.19.
 */

const WebViewPayments = function (name, options = {}) {
    Payments.call(this, name || connector.IAP);

    this.startTime = Date.now();

    this.nativePluginName = options.nativePluginName || "PurchasesPlugin";
    this.config = options.config || {};
};

WebViewPayments.prototype = Object.create(Payments.prototype);
WebViewPayments.prototype.constructor = WebViewPayments;

WebViewPayments.prototype.getProductId = function (config) {
    const ids = config.id;

    if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        return ids.ios;
    }

    if (connector.platform.oneOf(connector.ANDROID) && this.oneOf(connector.RUSTORE)) {
        return ids.android_rustore;
    }

    return ids[connector.info.source];
};

WebViewPayments.prototype._loadSubscriptionsTokens = function (callback) {
    if (this.oneOf(connector.RUSTORE) || connector.platform.oneOf(connector.ONESTORE, connector.AMAZON)) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    connector.platform.callNative(`${this.nativePluginName}.loadSubscriptionsTokens`, (code, response) => {
        if (code !== connector.CODE_SUCCEED) {
            return;
        }

        const purchases = response.purchases || [];

        if (purchases) {
            console.log(`WebViewPayments.onLoadSubscriptionsTokensResult purchases - ${purchases}`);
            this.addSubscriptionTokens(purchases);
        }

        callback(connector.CODE_SUCCEED);
    });
};

WebViewPayments.prototype.addSubscriptionTokens = function (products, restore) {
    if (!Array.isArray(products)) {
        products = [products];
    }

    if (!connector.platform.oneOf(connector.ANDROID, connector.IOS, connector.MACOS)) {
        return;
    }

    const tokens = products.map((product) => {
        const ourProduct = this.getProduct(product.productId);
        if (ourProduct && ourProduct.type === "subscription") {
            const token = {
                name: ourProduct.itemId
            };

            if (connector.platform.oneOf(connector.ANDROID)) {
                token.purchaseToken = product.purchaseToken || product.receipt.purchaseToken;
                token.packageName = product.packageName || product.receipt.packageName;
                token.productId = product.productId || product.receipt.productId;
            } else {
                token.purchaseToken = product.receipt;
                token.packageName = product.packageName;
                token.productId = product.productId;
            }

            return token;
        }
        return undefined;
    }).filter((token) => token);

    if (tokens.length > 0) {
        this.bus.trigger("subscriptionTokensLoaded", tokens, restore);
    }
};

WebViewPayments.prototype._connect = function (callback) {
    if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        callback(connector.STATUS_CONNECTED);
        return;
    }

    this.connectCallback = (code) => {
        callback(code === connector.CODE_SUCCEED ? connector.STATUS_CONNECTED : connector.STATUS_DISCONNECTED);
    };

    const appId = this.config.appId;

    connector.platform.callNative(`${this.nativePluginName}.connect`, { appId });
};

WebViewPayments.prototype.onCreated = function () {
    Payments.prototype.onCreated.call(this);

    if (!connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        connector.platform.subscribeNative("WebViewPayments", this.onNativeEvent.bind(this));
    }
};

WebViewPayments.prototype.onRemoved = function () {
    Payments.prototype.onRemoved.call(this);

    connector.platform.unsubscribeNative("WebViewPayments");
};

WebViewPayments.prototype.onNativeConnected = function (connected) {
    console.log(`WebViewPayments.updateConnected - ${connected}`);
    console.log(`WebViewPayments.updateConnected - ${this.isConnected()}`, typeof this.connectCallback);

    if (this.connectCallback) {
        this.connectCallback(connected ? connector.CODE_SUCCEED : connector.CODE_FAILED);
        delete this.connectCallback;
    }
};

WebViewPayments.prototype.onNativeEvent = function (name, options) {
    switch (name) {
        case "updateConnected":
            this.onNativeConnected(options.connected); break;
        case "requestRestore":
            connector._paymentsManager.restoreThrottled(); break;
    }
};

WebViewPayments.prototype._loadProducts = function (callback) {
    const options = {
        productIds: this.listProductIdsOfType("consumable").join(",")
    };

    const nonConsumableProductIds = this.listProductIdsOfType("nonConsumable").join(",");
    if (nonConsumableProductIds) {
        options.nonConsumableProductIds = nonConsumableProductIds;
    }

    connector.platform.callNative(`${this.nativePluginName}.loadProducts`, options, (code, response) => {
        const products = response.products || [];
        const loadedIds = products.map((product) => product.productId);

        this.onLoadResult(code, "inapp", products);

        callback(code, loadedIds);
    });
};

WebViewPayments.prototype._loadSubscriptions = function (callback) {
    const subscriptionIds = this.listProductIdsOfType("subscription");

    if (this.oneOf(connector.RUSTORE) || connector.platform.oneOf(connector.AMAZON, connector.ONESTORE)) {
        callback(connector.CODE_SUCCEED, subscriptionIds);
        return;
    }

    connector.platform.callNative(`${this.nativePluginName}.loadSubscriptions`, { productIds: subscriptionIds.join(",") }, (code, response) => {
        const products = response.products || [];
        const loadedIds = products.map((product) => product.productId);

        this.onLoadResult(code, "subscription", products);

        callback(code, loadedIds);
    });
};

WebViewPayments.prototype.onLoadResult = function (code, type, products) {
    console.log(`WebViewPayments.onLoadResult code - ${code} type - ${type}`);
    if (code !== connector.CODE_SUCCEED) {
        console.log("WebViewPayments.onLoadResult failure");
        return;
    }

    console.log(`WebViewPayments.onLoadResult products - ${JSON.stringify(products)}`);

    let currency;

    products.forEach((product) => {
        const ourProduct = this.getProduct(product.productId);
        const productCurrency = product.price_currency_code;
        currency = currency || productCurrency;

        if (ourProduct !== undefined) {
            if (connector.platform.oneOf(connector.AMAZON)) {
                const match = product.price.match(/[0-9.,]+/g);
                if (match && match[0]) {
                    ourProduct.price = parseFloat(match[0].replace(",", "."));
                } else {
                    this.bus.trigger("stream:error", `Error parsing amazon price ${product.price}`);
                }
            } else {
                ourProduct.price = Math.round(product.price_amount_micros / 1000) / 1000;
            }

            ourProduct.textPrice = product.price || this.getTextPrice(ourProduct.price, productCurrency);
            ourProduct.currency = productCurrency;

            console.log(`WebViewPayments product ${product.productId} ${ourProduct.textPrice} ${ourProduct.currency} ${ourProduct.price}`);
        }
    });

    if (currency) {
        this.currency = currency;
        connector._countryManager.setCurrency(currency);
    }
};

WebViewPayments.prototype.extractPaymentId = function (nativePurchase) {
    let paymentId = (nativePurchase.orderId || nativePurchase.receipt.orderId || "");

    if (paymentId.length > 50) {
        paymentId = (`${Math.abs(connector.utils.hashCode(paymentId))}-${paymentId}`).substring(0, 50);
    }
    return paymentId;
};

WebViewPayments.prototype.extractPayload = function (nativePurchase) {
    const payload = {};

    if (this.oneOf(connector.RUSTORE)) {
        payload.orderId = nativePurchase.orderId;
        payload.purchaseId = nativePurchase.purchaseId;
        payload.invoiceId = nativePurchase.invoiceId;
        payload.sandbox = nativePurchase.sandbox;
        payload.purchaseType = nativePurchase.purchaseType;
    } else if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        payload.packageName = nativePurchase.packageName;
        payload.receipt = nativePurchase.receipt;
        payload.event = nativePurchase.purchase_date_ms || nativePurchase.purchaseDate;
    } else if (connector.platform.oneOf(connector.ANDROID, connector.GPG, connector.ONESTORE)) {
        payload.packageName = nativePurchase.receipt.packageName;
        payload.receipt = nativePurchase.receipt.purchaseToken;
        payload.event = nativePurchase.receipt.purchaseTimeMillis || nativePurchase.receipt.purchaseTime;

        payload.purchaseState = nativePurchase.purchaseState;
    } else if (connector.platform.oneOf(connector.AMAZON)) {
        payload.storeUserId = nativePurchase.storeUserId;
        payload.environment = nativePurchase.environment;
        payload.orderId = nativePurchase.orderId;
        payload.receiptId = nativePurchase.receiptId;
        payload.purchaseToken = nativePurchase.purchaseToken;
        payload.purchaseDate = nativePurchase.purchaseDate;
    }

    return payload;
};

WebViewPayments.prototype.purchase = function (product, callback) {
    const data = {
        productId: product.productId,
        userId: connector.platform.getUserID()
    };

    connector.platform.callNative(`${this.nativePluginName}.purchase`, data, (code, response) => {
        if (code === connector.CODE_CANCELLED) {
            callback(ERRORS.PURCHASE.CANCEL);
            return;
        }

        if (code === connector.CODE_PENDING) {
            callback(ERRORS.PURCHASE.PENDING, undefined, { error: "pending" });
            return;
        }

        if (code !== connector.CODE_SUCCEED) {
            callback(ERRORS.PURCHASE.UNKNOWN, undefined, response);
            return;
        }

        const nativePurchase = response.purchase;
        if (!nativePurchase) {
            this.bus.trigger("stream:error", `WebViewPayments.purchase no nativePurchase productId: ${product.productId}`);

            callback(ERRORS.PURCHASE.UNKNOWN);
            return;
        }

        const paymentId = this.extractPaymentId(nativePurchase);
        const payload = this.extractPayload(nativePurchase);

        console.log(`WebViewPayments.purchase paymentId - ${paymentId}`);
        console.log(`WebViewPayments.purchase nativePurchase - ${JSON.stringify(nativePurchase)}`);

        const purchase = this.createPurchase(paymentId, product, payload);

        if (connector.platform.oneOf(connector.AMAZON) && connector.config.debugMode) {
            this.bus.trigger("stream:console", `AMAZON_PAYMENTS Purchase - ${JSON.stringify(purchase)}`);
        }

        this.addSubscriptionTokens(nativePurchase);

        callback(connector.CODE_SUCCEED, purchase);
    });
};

WebViewPayments.prototype.validate = function (purchase, callback) {
    if (!connector.platform.oneOf(connector.ANDROID, connector.IOS, connector.MACOS, connector.GPG, connector.AMAZON)) {
        callback(connector.CODE_SUCCEED, purchase);
        return;
    }

    const data = {
        purchase,
        version: 2
    };

    if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        data.platform = "apple";
    } else if (connector.platform.oneOf(connector.AMAZON)) {
        data.platform = "amazon";
    } else {
        data.platform = "google";
    }

    ConnectorRestClient.post("/purchasevalidator/validate", data, (response) => {
        if (response.error) {
            this.bus.trigger("stream:error", new Error(`WebViewPayments.validate ${data.platform} productId:${purchase.productId} ${response.error}`));
            callback(response.transient ? connector.CODE_CANCELLED : connector.CODE_FAILED, purchase);
            return;
        }

        purchase.paymentId = purchase.paymentId
            || response.receipt && response.receipt.orderId
            || response.transaction_id || response.transactionId
            || response.purchaseId
            || response.order && response.order.orderId;
        console.log(`WebViewPayments.validate Success: ${JSON.stringify(response)}`);
        callback(connector.CODE_SUCCEED, purchase);
    }, () => {
        console.log("WebViewPayments.validate onError");
        callback(connector.CODE_CANCELLED);
    });
};

WebViewPayments.prototype.getTextPrice = function (price, currency) {
    price = String(price);
    if (price.indexOf(".") === -1) {
        price += ".00";
    }

    return Payments.prototype.getTextPrice.call(this, price, currency);
};

// Amazon: none of 703 failed purchases arrived later
WebViewPayments.prototype.canDeliverLate = function () {
    return !connector.platform.oneOf(connector.AMAZON);
};

WebViewPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.ANDROID, connector.AMAZON, connector.IOS, connector.MACOS);
};

WebViewPayments.prototype.isRestoreAvailable = function () {
    if (connector.platform.oneOf(connector.IOS, connector.MACOS) && (!this.productsLoaded || !this.subscriptionsLoaded)) {
        return false;
    }

    return connector.payments.isConnected();
};

WebViewPayments.prototype.restore = function (callback) {
    if (!this.oneOf(connector.RUSTORE) && !connector.platform.oneOf(
        connector.ANDROID,
        connector.GPG,
        connector.IOS,
        connector.MACOS,
        connector.ONESTORE
    )) {
        callback(connector.CODE_FAILED);
        return;
    }

    connector.platform.callNative(`${this.nativePluginName}.restore`, (code, response) => {
        if (code !== connector.CODE_SUCCEED) {
            callback(connector.CODE_FAILED);
            return;
        }

        const nativePurchase = response.purchase;

        if (!nativePurchase) {
            this.bus.trigger("stream:error", "WebViewPayments.restore no nativePurchase");

            callback(connector.CODE_FAILED);
            return;
        }

        const paymentId = this.extractPaymentId(nativePurchase);
        if (!paymentId) {
            this.bus.trigger("stream:error", `WebViewPayments.restore no paymentId nativePurchase: ${JSON.stringify(nativePurchase)}`);

            callback(connector.CODE_FAILED);
            return;
        }

        let productId;
        if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
            productId = nativePurchase.productId;
        } else {
            productId = nativePurchase.productId || nativePurchase.receipt.productId;
        }

        if (!productId) {
            this.bus.trigger("stream:error", `WebViewPayments.restore no productId nativePurchase: ${JSON.stringify(nativePurchase)}`);

            callback(connector.CODE_FAILED);
            return;
        }

        const product = this.getProduct(productId);
        if (!product) {
            this.bus.trigger("stream:error", `WebViewPayments.restore no product for productId: ${productId} nativePurchase: ${JSON.stringify(nativePurchase)}`);

            callback(connector.CODE_FAILED);
            return;
        }

        const payload = this.extractPayload(nativePurchase);

        const purchase = this.createPurchase(paymentId, product, payload);

        console.log(`WebViewPayments.restore Success: ${JSON.stringify({ ...purchase, payload: undefined })}`);

        callback(connector.CODE_SUCCEED, purchase);
    });
};

WebViewPayments.prototype.consume = function (purchase, callback) {
    if (this.oneOf(connector.RUSTORE) || connector.platform.oneOf(connector.ANDROID, connector.IOS, connector.MACOS, connector.ONESTORE)) {
        console.log(`WebViewPayments.consume orderId=${purchase.paymentId} productId=${purchase.productId}`);

        connector.platform.callNative(`${this.nativePluginName}.consumePurchase`, {
            orderId: purchase.paymentId,
            productId: purchase.productId
        }, (code) => {
            console.log(`WebViewPayments.consume result code=${code} orderId=${purchase.paymentId}`);
        });
    }

    callback(connector.CODE_SUCCEED);
};

WebViewPayments.prototype.restoreSubscriptions = function (callback) {
    callback = connector.utils.once(callback);

    if (!connector.payments.isConnected()) {
        callback(connector.CODE_FAILED);
        return;
    }

    connector.platform.callNative(`${this.nativePluginName}.restoreSubscriptions`, (code, response) => {
        const purchases = response.purchases;

        console.log(`WebViewPayments.onRestoreSubscriptionsResult code - ${code}`);

        if (purchases) {
            console.log(`IOSPayments.onRestoreSubscriptionsResult purchases - ${purchases.length}`, purchases);
        }

        if (code === connector.CODE_SUCCEED) {
            callback(connector.CODE_SUCCEED);
            this.addSubscriptionTokens(purchases, true);
        } else {
            callback(connector.CODE_FAILED);
        }
    });
};
